import Nav from "./nav"
import Search from "./search"
import Swiper from "./swiper"
import Fancybox from "./fancybox"
import MiniCart from "./mini-cart"
import ProductVariation from "./product-variation"
import ProductSubscription from "./product-subscription"
import MobileNav from "./mobile-nav"
import ProductFilter from "./product-filter"
import JudgeMe from "./judgeme"
import Select2 from "./select2"
import Zendesk from "./zendesk"
import Cmp from "./cmp"
import LanguageSwitcher from "./language-switcher"
import StoreLocator from "./store-locator"
import MondialRelayShippingSync from "./mondialrelay-shipping-sync"
import CartSubscriptionConflict from "./cart-subscription-conflict"
import Withdrawal from "./withdrawal"
import QuantityStepper from "./quantity-stepper"

document.addEventListener("DOMContentLoaded", function () {
  Nav(jQuery)
  Search(jQuery)
  Swiper(jQuery)
  Fancybox(jQuery)
  MiniCart(jQuery)
  ProductVariation(jQuery)
  ProductSubscription(jQuery)
  MobileNav(jQuery)
  ProductFilter(jQuery)
  JudgeMe(jQuery)
  Select2(jQuery)
  Zendesk(jQuery)
  Cmp(jQuery)
  LanguageSwitcher(jQuery)
  StoreLocator(jQuery)
  MondialRelayShippingSync(jQuery)
  CartSubscriptionConflict(jQuery)
  Withdrawal(jQuery)
  QuantityStepper(jQuery)
})
